module.exports = __webpack_public_path__ + "static/img/test.ae54e4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/test.png
// module id = 2FlR
// module chunks = 1